import { FormikProps } from "formik";
import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import { FormRadio, FormRadioList } from "../../form/FormRadio";
import ForsikringsselskabField from "../../form/ForsikringsselskabField";
import ValidationError from "../../form/ValidationError";
import { Heading4, Heading5 } from "../Headings";
import { getTexts } from "../texts";
import { TilsynserklaeringFormValues } from "../../../interfaces/tilsynserklaering";
import ValidatedField from "../../form/ValidatedField";
import IsRequired from "../../form/IsRequired";
import { tilsynSection1CompleteHelper } from "../../../util/tilsynserklaering/isComplete";

const TilsynerklaeringSection1 = ({
  texts,
  props,
}: {
  texts: ReturnType<typeof getTexts>;
  props: FormikProps<TilsynserklaeringFormValues>;
}) => {
  const { values, errors, touched } = props;

  const { section1IsStarted, section1IsComplete } =
    tilsynSection1CompleteHelper(values, errors, touched);

  return (
    <AccordionItem value="1">
      <AccordionHeader
        sectionStarted={section1IsStarted}
        sectionComplete={section1IsComplete}
      >
        {texts.section1.title}
      </AccordionHeader>
      <AccordionBody>
        <div className="vstack gap-5">
          <div>
            <Heading4>{texts.section1.section1_1.title}</Heading4>
            <Heading5>
              {texts.section1.section1_1.question.label} <IsRequired />
            </Heading5>
            <FormRadioList>
              {texts.section1.section1_1.question.options.map((option) => (
                <FormRadio
                  name={texts.section1.section1_1.question.id}
                  value={option.value}
                  key={option.value}
                  invalid={
                    errors?.[texts.section1.section1_1.question.id] &&
                    touched?.[texts.section1.section1_1.question.id]
                  }
                >
                  {option.label}
                </FormRadio>
              ))}
              <ValidationError
                error={errors?.[texts.section1.section1_1.question.id]}
                show={touched?.[texts.section1.section1_1.question.id]}
              />
            </FormRadioList>
          </div>
          <div>
            <Heading4>{texts.section1.section1_2.title}</Heading4>
            <div className="row">
              <div className="col">
                <label
                  className="form-label"
                  htmlFor={texts.section1.section1_2.question.id}
                >
                  {texts.section1.section1_2.question.label} <IsRequired />
                </label>
                <ForsikringsselskabField
                  name={texts.section1.section1_2.question.id}
                  isInvalid={
                    errors?.[texts.section1.section1_2.question.id] &&
                    touched?.nuvaerendeForsikringsselskab
                  }
                />
                {values?.nuvaerendeForsikringsselskab?.id === "andet" && (
                  <div className="col mt-5">
                    <label
                      className="form-label"
                      htmlFor={texts.section1.section1_2.question2.id}
                    >
                      {texts.section1.section1_2.question2.label}
                      <IsRequired />
                    </label>
                    <ValidatedField
                      error={
                        props.errors?.[texts.section1.section1_2.question2.id]
                      }
                      touched={
                        touched?.[texts.section1.section1_2.question2.id]
                      }
                      id={texts.section1.section1_2.question2.id}
                      name={texts.section1.section1_2.question2.id}
                      autoComplete="off"
                      wrapper
                    />
                  </div>
                )}
              </div>
              <div className="col position-relative d-flex flex-column justify-content-end">
                <label
                  className="form-label"
                  htmlFor={texts.section1.section1_2.question3.id}
                >
                  {texts.section1.section1_2.question3.label}
                  {props.errors?.[texts.section1.section1_2.question3.id] ? (
                    <IsRequired />
                  ) : (
                    ""
                  )}
                </label>
                <ValidatedField
                  error={props.errors?.[texts.section1.section1_2.question3.id]}
                  touched={touched?.[texts.section1.section1_2.question3.id]}
                  id={texts.section1.section1_2.question3.id}
                  name={texts.section1.section1_2.question3.id}
                  placeholder="Fx. 12345678"
                  wrapper
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        </div>
      </AccordionBody>
    </AccordionItem>
  );
};

export default TilsynerklaeringSection1;
